import { render, staticRenderFns } from "./CustomerOrderDetail.vue?vue&type=template&id=428f50c6&scoped=true&"
import script from "./CustomerOrderDetail.vue?vue&type=script&lang=js&"
export * from "./CustomerOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./CustomerOrderDetail.vue?vue&type=style&index=0&id=428f50c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428f50c6",
  null
  
)

export default component.exports